import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { generateClassNameForReverseType } from 'helpers/transactions'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const systemCustomCorporateActionColumns: GridColumn[] = [
  {
    title: 'Symbol',
    field: 'instrument.symbol',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.instrument || !props.dataItem.instrument.symbol) {
        return <td />
      }
      return <td className='columns__content'>{props.dataItem.instrument.symbol}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Type',
    field: 'corporateActionType.name',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.corporateActionType) {
        return <td />
      }
      return <td className='columns__content'>{props.dataItem.corporateActionType.name}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Notes',
    field: 'notes',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.notes) {
        return <td />
      }
      return <td className='columns__content'>{props.dataItem.notes}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Updated',
    field: 'lastUpdatedAt',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.lastUpdatedAt) {
        return <td />
      }
      return (
        <td className={generateClassNameForReverseType(props.dataItem, 'date')}>
          {formatLocalDateUTC(props.dataItem.lastUpdatedAt, true)}
        </td>
      )
    },
    resizable: false,
    sortable: false,
    show: true,
  },
  {
    title: 'Excluded',
    field: 'isExcluded',
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td className='table-columns__date'>
          <input type='checkbox' checked={props.dataItem.isExcluded} readOnly />
        </td>
      )
    },
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Deleted',
    field: 'isDeleted',
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td className='table-columns__date'>
          <input type='checkbox' checked={props.dataItem.isDeleted} readOnly />
        </td>
      )
    },
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Processed',
    field: 'isProcessed',
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td className='table-columns__date'>
          <input type='checkbox' checked={props.dataItem.isProcessed} readOnly />
        </td>
      )
    },
    className: 'table-columns__content',
    filter: 'text',
  },
]

export default systemCustomCorporateActionColumns
